import {Shipment} from "@models/shipment.interface";

export const SEARCH_RESULT_UPDATE = 'SEARCH_RESULT_UPDATE';
export const SEARCH_RESULT_ADD = 'SEARCH_RESULT_ADD';
export const SEARCH_RESULT_REMOVE = 'SEARCH_RESULT_REMOVE';
export const ACTIVE_SEARCH_SET = 'ACTIVE_SEARCH_SET';
export const ACTIVE_SEARCH_REMOVE = 'ACTIVE_SEARCH_REMOVE';
export const SHIPMENT_ADD = 'SHIPMENT_ADD';
export const SHIPMENT_REMOVE = 'SHIPMENT_REMOVE';
export const SHIPMENT_UPDATE = 'SHIPMENT_UPDATE';
export const SEARCH_RESULTS_REMOVE = 'SEARCH_RESULTS_REMOVE';
export const ORDER_CREATION_CLEAR = 'ORDER_CREATION_CLEAR';
export const ORDER_SUMMARY_CLEAR = 'ORDER_SUMMARY_CLEAR';

export const CLEAR_ORDER_CREATION_STATE = '[ORDER CREATION] CLEAR_STATE';

export class ShipmentAdd {
  readonly type = SHIPMENT_ADD;
  constructor(public payload: {shipment: Shipment}) {}
}

export class ShipmentUpdate {
  readonly type = SHIPMENT_UPDATE;
  constructor(public payload: {shipment: Shipment}) {}
}

export class ShipmentRemove {
  readonly type = SHIPMENT_REMOVE;
  constructor(public payload: {id: string}) {}
}

export class DeleteAllShipmentsInCart {
  readonly type = ORDER_SUMMARY_CLEAR;
}

export class ClearOrderCreationState {
  readonly type = CLEAR_ORDER_CREATION_STATE;
}



// WEBPACK FOOTER //
// ./src/app/store/actions/order-creation.action.ts